const AUTH_COOKIES = ["Authorization_windbug", "email_windbug", "is_project_owner"];

function domainAttr() {
  return window.location.hostname.endsWith("sirpi.co.in")
    ? ";domain=.sirpi.co.in"
    : "";
}

// Always write auth cookies on path "/" so every page reads and overwrites the
// same cookie instead of creating path-specific duplicates.
export function setAuthCookie(cname, cvalue, minutes) {
  var date = new Date();
  date.setTime(date.getTime() + minutes * 60 * 1000);
  document.cookie =
    cname + "=" + cvalue + ";expires=" + date.toGMTString() + ";path=/" + domainAttr() + ";";
}

// Remove every variant of the auth cookies (host-only and .sirpi.co.in, root
// path and current path). A stale expired token left behind in any of these
// is sent alongside the fresh one after re-login and makes the backend answer
// 401 again, bouncing the user straight back to the login page.
export function clearAuthCookies() {
  var expired = ";expires=Thu, 01 Jan 1970 00:00:00 GMT";
  var paths = ["/", window.location.pathname];
  var domains = ["", ";domain=" + window.location.hostname];
  if (window.location.hostname.endsWith("sirpi.co.in")) {
    domains.push(";domain=.sirpi.co.in");
  }
  AUTH_COOKIES.forEach((name) => {
    paths.forEach((path) => {
      domains.forEach((domain) => {
        document.cookie = name + "=" + expired + ";path=" + path + domain + ";";
      });
    });
  });
}
